<svelte:options runes={false} />

<script>
  export let message;
  export let variant = 'notice';
  export let position = 'bottom';
  export let stack = 0;

  let dismissedMessage = '';

  function dismiss() {
    dismissedMessage = message;
  }

  $: offset = `${1.25 + stack * 3.5}rem`;
</script>

{#if message && message !== dismissedMessage}
  <div
    class="notice toast"
    class:error={variant === 'error'}
    style={position === 'top' ? `top: ${offset};` : `bottom: ${offset};`}
    role={variant === 'error' ? 'alert' : 'status'}
  >
    <span>{message}</span>
    <button type="button" class="dismiss" on:click={dismiss} aria-label="Dismiss message">✖</button>
  </div>
{/if}

<style>
  .toast {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    z-index: 60;
    display: flex;
    align-items: center;
    gap: 0.75rem;
    max-width: min(92vw, 40rem);
    box-shadow: var(--shadow);
  }

  .dismiss {
    flex: none;
    background: none;
    border: none;
    cursor: pointer;
    font-weight: 700;
    font-size: 1rem;
    line-height: 1;
    padding: 0;
    color: inherit;
  }
</style>
